// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "fyiapp-20181113101933--hostingbucket",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1qwtatyxn3sxx.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:7b6d7b6e-4541-4a46-9d21-3c3ebd1d84b4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Jkyc5ULxl",
    "aws_user_pools_web_client_id": "7p37pgllndal9evnjq4shsjsef",
    "aws_cloud_logic_custom": [
        {
            "name": "trailers",
            "endpoint": "https://tqw8j6rbf5.execute-api.us-east-1.amazonaws.com/Prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js